import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Flex,
  Text,
  Box,
  useToast,
} from '@chakra-ui/react';
import React, { useState } from 'react';

import { formatMultiSelectCfidOptions } from './utils';
import { Select } from 'packages/common-frontend/components/Select';
import { errorToastConfig } from 'packages/common-frontend/constants';

export const AssignmentMultiAssignModal: React.FC<{
  getNumberOfSelectedReceivables: () => number;
  getSharedAssignableCfidOptions: () => string[];
  creditFacilitiesForBorrowerMap: {
    [key: string]: { id: string; borrowerEntityName: string };
  };
  onApply: (value: string) => void;
}> = ({
  getSharedAssignableCfidOptions,
  creditFacilitiesForBorrowerMap,
  getNumberOfSelectedReceivables,
  onApply,
}) => {
  const toast = useToast();

  const [isOpen, setIsOpen] = useState(false);
  const [selectedBorrowerEntityName, setSelectedBorrowerEntityName] = useState<
    string | null
  >(null);

  const numberOfSelectedReceivables = getNumberOfSelectedReceivables();

  return (
    <Box zIndex={200} mr="30px">
      <Button
        onClick={() => {
          setIsOpen(true);
        }}
      >
        Update proposed owners
      </Button>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <ModalOverlay />
        <ModalContent padding="20px" minW="2xl">
          <ModalHeader>
            Update proposed owner for selected receivables
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody width="100%">
            {!numberOfSelectedReceivables ? (
              <Box>
                <Text>
                  No receivables have been selected. Please select one or more
                  receivables for updating the proposed owner.
                </Text>
                <Flex justifyContent="center" mt="8">
                  <Button
                    onClick={() => {
                      setIsOpen(false);
                    }}
                    aria-label="Close"
                  >
                    Close
                  </Button>
                </Flex>
              </Box>
            ) : (
              <Box>
                <Text>
                  {`Update ${numberOfSelectedReceivables} selected receivables to the following proposed owner: `}
                </Text>
                <Flex alignItems="flex-end" flexDirection="row" mt={5} mb={10}>
                  <Select
                    onChange={(val) => {
                      setSelectedBorrowerEntityName(val ?? null);
                    }}
                    value={selectedBorrowerEntityName}
                    options={formatMultiSelectCfidOptions(
                      getSharedAssignableCfidOptions(),
                      creditFacilitiesForBorrowerMap,
                    )}
                    placeholderLabel="Select new proposed owner"
                  />
                </Flex>
                <Text>
                  Clicking Apply below will update the proposed owner in your
                  current edit view. It will not submit any assignments
                </Text>
                <Flex justifyContent="center" mt="8">
                  <Button
                    onClick={() => {
                      if (selectedBorrowerEntityName) {
                        setIsOpen(false);
                        onApply(selectedBorrowerEntityName);
                      } else {
                        errorToastConfig.title = `Error previewing assignment`;
                        toast(errorToastConfig);
                      }
                    }}
                    aria-label="Done"
                    disabled={!selectedBorrowerEntityName}
                  >
                    Apply
                  </Button>
                </Flex>
              </Box>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};
